"use client"

import { ChevronRight, Home } from "lucide-react"
import Link from "next/link"

interface BreadcrumbItem {
  label: string
  href?: string
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
}

export function Breadcrumb({ items }: BreadcrumbProps) {
  return (
      <nav aria-label="Breadcrumb" className="bg-transparent">
        <div className="container mx-auto">
          <ol className="flex items-center justify-center space-x-2 text-xs md:text-base">
            <li>
              <Link
                href="/"
                className="flex items-center text-white"
                aria-label="Voltar para página inicial"
              >
                <Home className="h-4 w-4 text-white" />
                <span className="sr-only">Início</span>
              </Link>
            </li>

            {items.map((item, index) => (
              <li key={index} className="flex items-center">
                <ChevronRight className="h-4 w-4 text-white mx-2" />
                {item.href && index < items.length - 1 ? (
                  <Link
                    href={item.href}
                    className="text-white tracking-widest"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <p className="text-white tracking-widest" aria-current="page">
                    {item.label}
                  </p>
                )}
              </li>
            ))}
          </ol>
        </div>
      </nav>

  )
}
